import { render } from "./SettingsModal.vue?vue&type=template&id=7552fe28&scoped=true&ts=true"
import script from "./SettingsModal.vue?vue&type=script&lang=ts"
export * from "./SettingsModal.vue?vue&type=script&lang=ts"

import "./SettingsModal.vue?vue&type=style&index=0&id=7552fe28&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7552fe28"]])

export default __exports__